export default "__VITE_ASSET__comusSnJ__"